import { useEffect } from 'react';

const BASE_TITLE = 'پنل اتومیشن اینستاگرام';

export default function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
